<div class="container mx-auto px-0 py-0">
  <div class="bg-white shadow-md rounded-lg p-6">
    <div class="flex justify-between items-center mb-6">
       <div class="flex items-center space-x-2">
         <button (click)="goBackToList()" mat-icon-button class="text-gray-600 hover:text-gray-800">
           <mat-icon>arrow_back</mat-icon>
         </button>
         <h2 class="text-2xl font-bold mb-0">
           {{ isNewClient ? ('CLIENT_EDIT.TITLE_NEW' | translate) : (isEditMode ? ('CLIENT_EDIT.TITLE_EDIT' | translate) : ('CLIENT_EDIT.TITLE_VIEW' | translate)) }}: 
           <span *ngIf="!isNewClient && client">{{ client.suchbegriff }}</span>
         </h2>
       </div>
       <div class="flex space-x-2"></div>
     </div>
    <div class="row">
      <div class="col-md-12 order-md-1 order-sm-2">

        <!-- Loading State for Existing Client -->
        <div *ngIf="isLoading && !isNewClient" class="flex justify-center items-center py-8">
          <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
          <span class="ml-4 text-gray-600">{{ 'CLIENT_EDIT.LOADING' | translate }}</span>
        </div>

        <!-- Combined View/Edit Mode -->
         <form [formGroup]="clientForm" [class.opacity-50]="isLoading && !isNewClient" [class.pointer-events-none]="isLoading && !isNewClient">
           <mat-tab-group animationDuration="0ms" *ngIf="!isNewClient" (selectedIndexChange)="selectedTabIndex = $event" [selectedIndex]="selectedTabIndex">
             <mat-tab [label]="'CLIENT_EDIT.TAB_INFO' | translate">
               <div class="step-container d-flex align-items-start flex-column">
                 <div class="container-fluid mt-6">
                   <div class="form">
                     <div class="row">
                       <div class="col-12 col-lg-6">
                        <!-- Suchbegriff -->
                        <div class="form-group">
                          <label class="form-label" for="suchbegriff">{{ 'CLIENT_EDIT.FIELD_NAME' | translate }}</label>
                          <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                            {{ client?.suchbegriff || '-' }}
                          </div>
                          <input
                            *ngIf="isEditMode || isNewClient"
                            type="text"
                            class="form-control"
                            id="suchbegriff"
                            formControlName="suchbegriff"
                            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            [placeholder]="'CLIENT_EDIT.FIELD_NAME' | translate"
                            [class.is-invalid]="isFieldInvalid('suchbegriff')" />
                          <div *ngIf="isFieldInvalid('suchbegriff')" class="text-red-500 text-sm">{{ 'CLIENT_EDIT.VALIDATION_NAME' | translate }}</div>
                        </div>

                         <!-- Status ID -->
                         <div class="form-group">
                           <label class="form-label" for="status_id">{{ 'CLIENT_EDIT.FIELD_STATUS' | translate }}</label>
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ client?.status_id ? getStatusText(client.status_id) : '-' }}
                           </div>
                           <select
                             *ngIf="isEditMode || isNewClient"
                             class="form-control"
                             id="status_id"
                             formControlName="status_id"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
                             <option *ngFor="let status of clientStatusOptions" [value]="status.id">
                               {{ status.label }}
                             </option>
                           </select>
                         </div>

                         <!-- Startdatum -->
                         <div class="form-group">
                           <label class="form-label" for="startdatum">{{ 'CLIENT_EDIT.FIELD_CONTRACT_START' | translate }}</label>
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ formatDateForDisplay(client?.startdatum) || '-' }}
                           </div>
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="date"
                             class="form-control"
                             id="startdatum"
                             formControlName="startdatum"
                             placeholder="DD.MM.YYYY"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" />
                         </div>

                         <!-- Enddatum -->
                         <div class="form-group">
                           <label class="form-label" for="enddatum">{{ 'CLIENT_EDIT.FIELD_CONTRACT_END' | translate }}</label>
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ formatDateForDisplay(client?.enddatum) || '-' }}
                           </div>
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="date"
                             class="form-control"
                             id="enddatum"
                             formControlName="enddatum"
                             placeholder="DD.MM.YYYY"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" />
                         </div>

                         <!-- Address Section -->
                         <div class="form-group">
                           <label class="form-label" for="strasse">{{ 'CLIENT_EDIT.FIELD_STREET' | translate }}</label>
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ client?.strasse || '-' }}
                           </div>
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="text"
                             class="form-control"
                             id="strasse"
                             formControlName="strasse"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                             [placeholder]="'CLIENT_EDIT.FIELD_STREET' | translate" />
                           <div *ngIf="clientForm.get('strasse')?.invalid && clientForm.get('strasse')?.touched" class="text-red-500 text-sm">
                             {{ 'CLIENT_EDIT.VALIDATION_STREET' | translate }}
                           </div>
                         </div>

                         <div class="form-group">
                           <label class="form-label" for="plz">{{ 'CLIENT_EDIT.FIELD_ZIP' | translate }}</label>
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ client?.plz || '-' }}
                           </div>
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="text"
                             class="form-control"
                             id="plz"
                             formControlName="plz"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                             [placeholder]="'CLIENT_EDIT.FIELD_ZIP' | translate" />
                           <div *ngIf="clientForm.get('plz')?.invalid && clientForm.get('plz')?.touched" class="text-red-500 text-sm">
                             {{ 'CLIENT_EDIT.VALIDATION_ZIP' | translate }}
                           </div>
                         </div>

                         <div class="form-group">
                           <label class="form-label" for="ort">{{ 'CLIENT_EDIT.FIELD_CITY' | translate }}</label>
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ client?.ort || '-' }}
                           </div>
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="text"
                             class="form-control"
                             id="ort"
                             formControlName="ort"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                             [placeholder]="'CLIENT_EDIT.FIELD_CITY' | translate" />
                           <div *ngIf="clientForm.get('ort')?.invalid && clientForm.get('ort')?.touched" class="text-red-500 text-sm">
                             {{ 'CLIENT_EDIT.VALIDATION_CITY' | translate }}
                           </div>
                         </div>

                         <div class="form-group">
                           <label class="form-label" for="land">{{ 'CLIENT_EDIT.FIELD_COUNTRY' | translate }}</label>
                           <div *ngIf="!isEditMode && !isNewClient" class="detail-value">
                             {{ client?.land || '-' }}
                           </div>
                           <input
                             *ngIf="isEditMode || isNewClient"
                             type="text"
                             class="form-control"
                             id="land"
                             formControlName="land"
                             class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                             [placeholder]="'CLIENT_EDIT.FIELD_COUNTRY' | translate" />
                           <div *ngIf="clientForm.get('land')?.invalid && clientForm.get('land')?.touched" class="text-red-500 text-sm">
                             {{ 'CLIENT_EDIT.VALIDATION_COUNTRY' | translate }}
                           </div>
                         </div>
                       </div>

                       <div class="col-12 col-lg-6">
                          <!-- Anmerkungen Chat Section -->
                          <div class="form-group" *ngIf="!isEditMode && !isNewClient">
                            <div class="flex items-center justify-between mb-2">
                              <label class="form-label mb-0" for="anmerkungen">{{ 'CLIENT_EDIT.NOTES_LABEL' | translate }}</label>
                              <span *ngIf="sortedAnmerkungen && sortedAnmerkungen.length > 0" 
                                    class="px-2 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded-full">
                                {{ sortedAnmerkungen.length }}
                              </span>
                            </div>

                            <!-- Anmerkungen List (scrollable) -->
                            <div *ngIf="sortedAnmerkungen && sortedAnmerkungen.length > 0" 
                                 class="space-y-2 max-h-[350px] overflow-y-auto pr-2 mb-4 border border-gray-200 rounded-lg p-3 bg-gray-50">
                              <div *ngFor="let anmerkung of sortedAnmerkungen; let i = index" 
                                   class="flex items-start gap-3 p-3 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                                <!-- User Avatar -->
                                <div class="flex-shrink-0">
                                  <div class="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center text-white text-sm font-medium">
                                    {{ getUserInitials(anmerkung.username) }}
                                  </div>
                                </div>
                                
                                <!-- Anmerkung Content -->
                                <div class="flex-1 min-w-0">
                                  <div class="flex items-center gap-2 mb-1">
                                    <span class="text-sm font-medium text-gray-900">{{ anmerkung.username }}</span>
                                    <span class="text-xs text-gray-500">{{ formatAnmerkungDate(anmerkung.datetime) }}</span>
                                  </div>
                                  <div class="text-sm text-gray-700 whitespace-pre-wrap">{{ anmerkung.anmerkung }}</div>
                                </div>
                                
                                <!-- Action Button (admin only - delete only) -->
                                <div *ngIf="canEditAnmerkungen()" class="flex-shrink-0">
                                  <button
                                    (click)="deleteAnmerkung(anmerkung)"
                                    mat-icon-button
                                    class="mat-icon-button-small"
                                    [title]="'COMMON.DELETE' | translate">
                                    <mat-icon>close</mat-icon>
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Empty State -->
                            <div *ngIf="!sortedAnmerkungen || sortedAnmerkungen.length === 0" 
                                 class="text-center py-6 text-sm text-gray-500 mb-4 border border-gray-200 rounded-lg bg-gray-50">
                              <mat-icon class="w-8 h-8 mb-2 text-gray-400">comment</mat-icon>
                              <p>{{ 'CLIENT_EDIT.NOTES_EMPTY' | translate }}</p>
                            </div>

                            <!-- Add New Anmerkung Section -->
                            <div class="mt-4">
                              <label class="block text-sm font-medium text-gray-700 mb-2">{{ 'CLIENT_EDIT.NOTES_ADD' | translate }}</label>
                              <textarea
                                #anmerkungTextarea
                                [(ngModel)]="newAnmerkungText"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="onAnmerkungTextChange($event)"
                                [disabled]="isAddingAnmerkung"
                                rows="3"
                                class="w-full p-2.5 border border-gray-300 rounded-lg text-sm focus:ring-blue-500 focus:border-blue-500"
                                [placeholder]="'CLIENT_EDIT.NOTES_PLACEHOLDER' | translate"></textarea>
                              <div class="flex justify-end mt-2">
                                <button
                                  type="button"
                                  (click)="addAnmerkungFromTemplate($event)"
                                  [disabled]="!canAddAnmerkung"
                                  mat-raised-button
                                  color="primary"
                                  class="!text-xs !px-4 !py-1.5 !h-auto !min-h-0">
                                  <span *ngIf="isAddingAnmerkung">{{ 'CLIENT_EDIT.NOTES_ADDING' | translate }}</span>
                                  <span *ngIf="!isAddingAnmerkung">{{ 'CLIENT_EDIT.NOTES_ADD_BTN' | translate }}</span>
                                </button>
                              </div>
                              <p *ngIf="isNewClient" class="text-xs text-gray-500 mt-1">
                                {{ 'CLIENT_EDIT.NOTES_SAVE_ON_NEW' | translate }}
                              </p>
                            </div>
                          </div>
                       </div>

                      <!-- Action Buttons moved below tabs (global bottom bar) -->
                   </div>
                </div>
              </div>
              </div>
            </mat-tab>
             
             <mat-tab [label]="'CLIENT_EDIT.TAB_CONTACTS' | translate">
                <div class="kontakte-tab-content w-11/12 mx-auto">
                  <app-kontakte 
                    *ngIf="!isNewClient && client?.uuid" 
                    [kundeId]="client.uuid"
                    [isEmbedded]="true"
                    [parentContext]="'client-edit'">
                  </app-kontakte>
                  <div *ngIf="isNewClient || !client?.uuid" class="text-center py-8">
                    <mat-icon class="text-gray-400 text-6xl mb-4">contacts</mat-icon>
                    <p class="text-gray-500 text-lg">{{ 'CLIENT_EDIT.CONTACTS_EMPTY' | translate }}</p>
                  </div>
                </div>
              </mat-tab>
              
              <mat-tab [label]="'CLIENT_EDIT.TAB_LOCATIONS' | translate">
                <div class="standorte-tab-content w-11/12 mx-auto">
                  <app-standorte 
                    *ngIf="!isNewClient && client?.uuid" 
                    [kundeId]="client.uuid"
                    [isEmbedded]="true"
                    [parentContext]="'client-edit'">
                  </app-standorte>
                  <div *ngIf="isNewClient || !client?.uuid" class="text-center py-8">
                    <mat-icon class="text-gray-400 text-6xl mb-4">location_on</mat-icon>
                    <p class="text-gray-500 text-lg">{{ 'CLIENT_EDIT.LOCATIONS_EMPTY' | translate }}</p>
                  </div>
                </div>
              </mat-tab>

              <mat-tab [label]="'CLIENT_EDIT.TAB_HAUSVERWALTUNG' | translate">
                <div class="hausverwaltung-tab-content w-11/12 mx-auto min-h-[360px]">
                  <div *ngIf="hvLoading" class="flex justify-center items-center py-8">
                    <mat-progress-spinner color="primary" mode="indeterminate" diameter="32"></mat-progress-spinner>
                  </div>
                  <div *ngIf="!hvLoading && !hvRows.length" class="text-center py-8">
                    <mat-icon class="text-gray-400 text-6xl mb-4">apartment</mat-icon>
                    <p class="text-gray-500 text-lg">{{ 'CLIENT_EDIT.HV_NO_STANDORTE' | translate }}</p>
                  </div>
                  <div *ngIf="!hvLoading && hvRows.length" class="mt-2 flow-root overflow-visible">
                    <table class="relative min-w-full divide-y divide-gray-300 dark:divide-white/15">
                      <thead>
                        <tr>
                          <th scope="col" class="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0 dark:text-white">{{ 'CLIENT_EDIT.STANDORT' | translate }}</th>
                          <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">{{ 'CLIENT_EDIT.TAB_HAUSVERWALTUNG' | translate }}</th>
                          <th scope="col" class="whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-0"><span class="sr-only">Aktionen</span></th>
                        </tr>
                      </thead>
                      <tbody class="divide-y divide-gray-200 bg-white dark:divide-white/10 dark:bg-gray-900">
                        <tr *ngFor="let row of hvRows; let i = index" class="align-top" [ngClass]="{'bg-gray-50 dark:bg-gray-800': i % 2 === 1}">
                          <td class="whitespace-nowrap py-2 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 dark:text-white">{{ getStandortLabel(row.standort) }}</td>
                          <td class="px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                            <!-- Read/display mode -->
                            <ng-container *ngIf="assigningStandortId !== row.standort.id">
                              <a *ngIf="row.hausverwaltung"
                                (click)="openHausverwaltung(row.hausverwaltung.id)"
                                class="text-blue-600 hover:underline cursor-pointer">
                                {{ row.hausverwaltung.name }}
                              </a>
                              <span *ngIf="!row.hausverwaltung">—</span>
                            </ng-container>
                            <!-- Assign / edit mode -->
                            <div *ngIf="assigningStandortId === row.standort.id" class="relative max-w-xs">
                              <input
                                type="text"
                                class="block w-full rounded-md border-0 py-1.5 pl-3 pr-9 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-500 dark:bg-white/10 dark:text-white dark:ring-white/5"
                                [placeholder]="'CLIENT_EDIT.HV_SEARCH_PLACEHOLDER' | translate"
                                [value]="hvSearchValue"
                                (input)="onHvSearch($event)"
                                (focus)="showHvDropdown = true"
                                (blur)="onHvBlur()" />
                              <!-- Down caret -->
                              <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 text-gray-400">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="h-4 w-4">
                                  <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.168l3.71-3.938a.75.75 0 1 1 1.08 1.04l-4.25 4.5a.75.75 0 0 1-1.08 0l-4.25-4.5a.75.75 0 0 1 .02-1.06Z" clip-rule="evenodd" />
                                </svg>
                              </span>
                              <div
                                *ngIf="showHvDropdown && hvFilteredOptions.length > 0"
                                class="absolute left-0 z-[60] mt-1 w-full origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-800 dark:ring-white/10 max-h-60 overflow-y-auto">
                                <div class="py-1">
                                  <button
                                    *ngFor="let hv of hvFilteredOptions"
                                    type="button"
                                    class="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-white"
                                    (mousedown)="selectHv(row, hv)">
                                    <div class="font-medium">{{ hv.name }}</div>
                                    <div *ngIf="hv.ort" class="text-xs text-gray-400">{{ hv.ort }}</div>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td class="whitespace-nowrap py-2 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                            <ng-container *ngIf="assigningStandortId !== row.standort.id">
                              <button
                                type="button"
                                class="inline-flex items-center gap-x-1 rounded-md bg-white px-2.5 py-1.5 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:opacity-50 dark:bg-white/10 dark:text-white dark:ring-white/5 dark:hover:bg-white/20"
                                [disabled]="hvSaving"
                                (click)="startAssign(row)">
                                <mat-icon class="!text-base !h-4 !w-4">{{ row.hausverwaltung ? 'edit' : 'add' }}</mat-icon>
                                {{ (row.hausverwaltung ? 'CLIENT_EDIT.HV_CHANGE' : 'CLIENT_EDIT.HV_ASSIGN') | translate }}
                              </button>
                              <button
                                *ngIf="row.hausverwaltung"
                                type="button"
                                class="ml-1 inline-flex items-center rounded-md p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600 disabled:opacity-50 dark:hover:bg-white/5"
                                [disabled]="hvSaving"
                                [title]="'CLIENT_EDIT.HV_CLEAR' | translate"
                                (click)="clearHausverwaltung(row)">
                                <mat-icon class="!text-base !h-4 !w-4">link_off</mat-icon>
                              </button>
                            </ng-container>
                            <button
                              *ngIf="assigningStandortId === row.standort.id"
                              type="button"
                              class="inline-flex items-center rounded-md p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-700 dark:hover:bg-white/5"
                              [title]="'COMMON.CANCEL' | translate"
                              (click)="cancelAssign()">
                              <mat-icon class="!text-base !h-4 !w-4">close</mat-icon>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </mat-tab>

              <mat-tab [label]="'CLIENT_EDIT.TAB_DOCUMENTS' | translate">
                <div class="dokumente-tab-content w-11/12 mx-auto">
                  <app-dokumente 
                    *ngIf="!isNewClient && client?.uuid" 
                    [tableName]="'standort'"
                    [isClientView]="true"
                    [clientId]="client.uuid"
                    [isEmbedded]="true"
                    [parentContext]="'client-edit'">
                  </app-dokumente>
                  <div *ngIf="isNewClient || !client?.uuid" class="text-center py-8">
                    <mat-icon class="text-gray-400 text-6xl mb-4">folder</mat-icon>
                    <p class="text-gray-500 text-lg">{{ 'CLIENT_EDIT.DOCUMENTS_EMPTY' | translate }}</p>
                  </div>
                </div>
              </mat-tab>
           </mat-tab-group>

           <!-- Bottom action bar for existing client (visible only on first tab: Kunde Information) -->
           <div *ngIf="!isNewClient && selectedTabIndex === 0" class="mt-6 flex justify-between items-center">
             <!-- Left side - Delete button -->
             <div>
               <button
                 *ngIf="client && isEditMode"
                 (click)="deleteClient()"
                 mat-button
                 color="warn">
                 {{ 'COMMON.DELETE' | translate }}
               </button>
             </div>

             <!-- Right side - Action buttons -->
             <div class="flex space-x-4">
               <button
                 *ngIf="client && !isEditMode"
                 (click)="enterEditMode()"
                 mat-raised-button
                 color="primary">
                 {{ 'COMMON.EDIT' | translate }}
               </button>

               <button
                 *ngIf="client && isEditMode"
                 (click)="cancelEdit()"
                 mat-button>
                 {{ 'COMMON.CANCEL' | translate }}
               </button>

               <button
                 *ngIf="client && isEditMode"
                 (click)="saveClient()"
                 [disabled]="!clientForm.valid || isSaving"
                 mat-raised-button
                 color="primary">
                 <span *ngIf="isSaving">{{ 'CLIENT_EDIT.BTN_SAVING' | translate }}</span>
                 <span *ngIf="!isSaving">{{ 'COMMON.SAVE' | translate }}</span>
               </button>
             </div>
           </div>

           <!-- New Client Form (No Tabs) -->
           <div *ngIf="isNewClient" class="step-container d-flex align-items-start flex-column">
             <div class="container-fluid mt-6">
               <div class="form">
                 <div class="row">
                   <div class="col-12 col-lg-6">
                     <div class="form-group">
                       <label class="form-label" for="suchbegriff">{{ 'CLIENT_EDIT.FIELD_NAME' | translate }}</label>
                       <input
                         type="text"
                         class="form-control"
                         id="suchbegriff"
                         formControlName="suchbegriff"
                         [placeholder]="'CLIENT_EDIT.NAME_PLACEHOLDER' | translate"
                         [class.is-invalid]="clientForm.get('suchbegriff')?.invalid && clientForm.get('suchbegriff')?.touched"
                       />
                       <div *ngIf="clientForm.get('suchbegriff')?.invalid && clientForm.get('suchbegriff')?.touched" class="invalid-feedback">
                         {{ 'CLIENT_EDIT.NAME_REQUIRED' | translate }}
                       </div>
                     </div>
                   </div>

                   <div class="col-12 col-lg-6">
                     <div class="form-group">
                       <label class="form-label" for="status_id">{{ 'CLIENT_EDIT.FIELD_STATUS' | translate }}</label>
                       <select class="form-control" id="status_id" formControlName="status_id">
                         <option *ngFor="let status of clientStatusOptions" [value]="status.id">
                           {{ status.label }}
                         </option>
                       </select>
                     </div>
                   </div>

                   <div class="col-12 col-lg-6">
                     <div class="form-group">
                       <label class="form-label" for="startdatum">{{ 'CLIENT_EDIT.FIELD_CONTRACT_START' | translate }}</label>
                       <input type="date" class="form-control" id="startdatum" formControlName="startdatum" placeholder="DD.MM.YYYY" />
                     </div>
                   </div>

                   <div class="col-12 col-lg-6">
                     <div class="form-group">
                       <label class="form-label" for="enddatum">{{ 'CLIENT_EDIT.FIELD_CONTRACT_END' | translate }}</label>
                       <input type="date" class="form-control" id="enddatum" formControlName="enddatum" placeholder="DD.MM.YYYY" />
                     </div>
                   </div>
                 </div>
               </div>
               <!-- Action Buttons for New Client -->
               <div class="col-12 mt-6">
                 <div class="flex justify-end space-x-4">
                   <button (click)="cancel()" mat-button>{{ 'COMMON.CANCEL' | translate }}</button>
                   <button (click)="saveClient()" [disabled]="!clientForm.valid || isSaving" mat-raised-button color="primary">
                     <span *ngIf="isSaving">{{ 'CLIENT_EDIT.BTN_CREATING' | translate }}</span>
                     <span *ngIf="!isSaving">{{ 'CLIENT_EDIT.BTN_CREATE' | translate }}</span>
                   </button>
                 </div>
               </div>
             </div>
           </div>
         </form>

         <app-source-record-panel entityType="kunde" [entityId]="client?.id || client?.uuid"></app-source-record-panel>

       </div>
     </div>
   </div>
 </div>
